export const userConstants = {
  GET_USER_DATA_REQUEST: 'GET_USER_DATA_REQUEST',
  GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
  GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',

  TOGGLE_BUG_REPORT_VIS: 'TOGGLE_BUG_REPORT_VIS'
};
